import { render, staticRenderFns } from "./ShowDischarged.vue?vue&type=template&id=12e54d69&"
import script from "./ShowDischarged.vue?vue&type=script&lang=ts&"
export * from "./ShowDischarged.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e54d69')) {
      api.createRecord('12e54d69', component.options)
    } else {
      api.reload('12e54d69', component.options)
    }
    module.hot.accept("./ShowDischarged.vue?vue&type=template&id=12e54d69&", function () {
      api.rerender('12e54d69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ShowDischarged.vue"
export default component.exports